import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getSignUpPath = () => {
  return urlHelper('/sign-up');
};
